<div class="modal-signup modal-content max-width-80pe border-all-10px-modal">
  <div>
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header padding-bottom-10px border-bottom-1px">

        <div class="row" *ngIf="SelectedpatientDetails">
          <div class="col-md-1 ">
            <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.OwnerPatientImageFile" onError="this.src='dummy.jpg';">
          </div>
          <div class="col-md-4 padding-left-0px">
            <div class="row row-height-17px margin-left-0px">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.OwnerName}} </label>
              </div>
            </div>
            <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
              <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(for : {{SelectedpatientDetails.EggName}}) </label>
              </div>
            </div>
            <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
      <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
        <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
      </div>
    </div>-->
            <div class="row row-height-17px">
              <div class="col-md-12">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerAgeYears}},{{SelectedpatientDetails.OwnerFormattedCode}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-4">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.OwnerTelephone1}}</label>
              </div>
            </div>
            <div class="row row-height-17px">
              <div class="col-md-2 padding-right-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
              </div>
              <div class="col-md-9 padding-left-0px">
                <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
              </div>

            </div>

          </div>
          <div class="col-md-6  padding-right-0px">
            <!--<div class="row font-size-12px">
      <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
        <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
      </div>:
      <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="FollicularData2">
        <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
      </div>
    </div>-->
            <div class="row font-size-12px">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px" >
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Completed</label>
              </div>
            </div>
            <!--<div class="row font-size-12px" *ngIf="FollicularScanEndInfo">
              <div class="col-md-7 margin-left-auto text-align-right padding-right-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">Scan Date </label>
              </div>:
              <div class="col-md-2 padding-right-0px padding-left-10px">
                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularScanEndInfo.ScanDate | date:'MMM-dd-yyyy'}}</label>
              </div>
            </div>-->
            <!--<div class="row">
      <div class="col-md-1 margin-left-auto padding-left-7px">
        <div class=""><label class="margin-bottom-0px font-weight-normal">D</label></div>
        </div>
      <div class="col-md-1 padding-left-7px">
        <div class=""><label class="margin-bottom-0px font-weight-normal">S</label></div>
      </div>

       <div class="col-md-1 padding-left-7px">

        <div class=""><label class="margin-bottom-0px font-weight-normal">A</label></div>
      </div>

    </div>-->
            <div class="row margin-right-0px">
              <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
              </div>
              <div class="Dsa2" *ngIf="DSADetails">
                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
              </div>
              <div class="Dsa3" *ngIf="DSADetails">

                <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
              </div>

            </div>
          </div>
          <div class="col-md-1">
            <button type="button" class="close button:focus" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        <!--{{ sectionData.Title }}-->

       
      </div>
      <div class="card-body padding-bottom-0px padding-right-0px margin-left-0px padding-top-0px padding-left-0px">
        <div class="card">
          <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
            <div class="row nav-link-hand margin-right-0px margin-left-0px" id="edit-link">
              <div class="col-md-6 padding-right-0px">
                <label class="margin-bottom-0px font-size-16px font-weight-normal">
                  Ready for Pickup
                </label>
              </div>
              <div class="col-md-6  padding-right-0px display-edit">
                <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                <div class="row float-right">
                  <div class="col-md-9 margin-top-3px padding-left-0px" *ngIf="FollicularPickupEndInfo">
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                  </div>

                  <!--<div class="col-md-1">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printpickup()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>




              </div>

            </div>
          </div>
          <div class="chatsd product-chart-wrapper product-chat-follicular-popup agreement-chart-wrapper ps  padding-lrt " data-ps-id="dfsfsde">

            <div class="card-body">
              <div *ngIf="FollicularPickupEndInfo">
                <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                  <div class="accordion margin-bottom-20px" id="accordionExampleTrig">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTrig">
                        <div class="row">
                          <div class="col-md-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px"
                                      type="button" data-toggle="collapse" data-target="#collapseTrig" aria-expanded="true" aria-controls="collapseTrig">
                                Ovulation Trigger
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 " *ngIf="FollicularPickupEndInfo || PickupData2">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button (click)="SaveOvulationtrigger()"
                                    class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                    *ngIf="PickupData2.ActivityStatus !=='Completed'"
                                    [disabled]="Medicine.errors?.required || RecommendedPackage.errors?.required ">
                                    <!--*ngIf="!FollicularPickupEndInfo.IsPickedUp"
                                    [disabled]="Medicine.errors?.required || RecommendedPackage.errors?.required ">-->
                              Save
                              <i class="far fa-save nav-link-hand font-size-14 "></i>
                            </button>
                            <!--<div *ngIf="SelectedpatientDetails.ProtocolStartDate < SelectedpatientDetails.ProtocolEndDate || SelectedpatientDetails.ProtocolStartDate == SelectedpatientDetails.ProtocolEndDate">
      <button (click)="SaveOvulationtrigger()"
              class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
              *ngIf="!FollicularPickupEndInfo.IsPickedUp"
              [disabled]="Medicine.errors?.required || RecommendedPackage.errors?.required ">
        Save
        <i class="far fa-save nav-link-hand font-size-14 "></i>
      </button>
    </div>-->
                          </div>
                        </div>


                      </div>

                      <div id="collapseTrig" class="collapse show" aria-labelledby="headingTrig" data-parent="#accordionExampleTrig">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                          <div class="row my-profile-form">
                            <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                              <div class="row">
                                <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                  <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Trigger Type </label>
                                </div>


                                <div class="col-md-4">
                                  <CodeTypeValue CodeType="TRTYP"
                                                 id="FollicularPickupEndInfo.triggertype"
                                                 [(ngModel)]="FollicularPickupEndInfo.triggertype" SelectedValue="FollicularPickupEndInfo.triggertype"
                                                 name="FollicularPickupEndInfo.triggertype">
                                  </CodeTypeValue>


                                </div>

                              </div>


                            </div>
                          </div>
                          <div class="accordion margin-bottom-20px margin-top-3px" id="accordionExampleDOse1">
                            <div class="card margin-bottom-5px">
                              <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingDose1">
                                <div class="row">
                                  <div class="col-md-4 text-align-center padding-right-0px">
                                    <h5 class="mb-0 height-24px">
                                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px border-left-female" type="button" data-toggle="collapse" data-target="#collapseDoseOne" aria-expanded="true" aria-controls="collapseDoseOne">
                                        <h4 class="margin-bottom-0px margin-left-8px font-size-16px">Dose1</h4>
                                      </button>
                                    </h5>
                                  </div>

                                </div>


                              </div>

                              <div id="collapseDoseOne" class="collapse show" aria-labelledby="headingDOseOne" data-parent="#accordionExampleDOse1">
                                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                  <div class="card">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Trigger Date </label>
                                          </div>


                                          <div class="col-md-3">

                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d1.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>
                                              
                                            </div>

                                          </div>
                                          <div class="col-md-1 float-left">
                                            <a class="font-size-16px nav-link-hand color-Assign font-weight-normal"
                                               data-toggle="tooltip" data-placement="bottom"
                                               title="Trigger date should be in between protocol start and End date">
                                              <i class="fas fa-question margin-right-8em"></i>
                                            </a>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Trigger Time </label>
                                          </div>


                                          <div class="col-md-3">


                                            <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.TriggerTime" placeholder="Schedule Time"
                              [(ngModel)]="FollicularPickupEndInfo.TriggerTime"
                              name="FollicularPickupEndInfo.TriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                            <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.OvulationTriggerTime" placeholder="Trigger Time"
                              [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"
                              name="FollicularPickupEndInfo.OvulationTriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                            <input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime" name="FollicularPickupEndInfo.OvulationTriggerTime">
                                            <ngx-material-timepicker #picker></ngx-material-timepicker>
                                            <!--<ngb-timepicker [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"></ngb-timepicker>-->
                                          </div>
                                          <div class="col-md-3 margin-tg-auto">
                                              <label
                                                     class="margin-bottom-0px ">
                                              {{FollicularPickupEndInfo.OvulationTriggerTime| slice:11}}</label>
                                            </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Medicine </label>
                                          </div>


                                          <div class="col-md-4">
                                            <CustomDataByRequestType RequestedType="IvfFolTriggerMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue="FollicularPickupEndInfo.MedicineCode"
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required #Medicine="ngModel">
                                            </CustomDataByRequestType>


                                          </div>
                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px "
                                                   *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.MedicineName}}</label>
                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Dose </label>
                                          </div>


                                          <div class="col-md-3">

                                            <input type="text" class="form-control" placeholder="Dose" id="FollicularPickupEndInfo.Dosage"
                                                   [(ngModel)]="FollicularPickupEndInfo.Dosage" required
                                                   name="FollicularPickupEndInfo.Dosage" pattern="^[\0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                                   maxlength="5">

                                            <small class="form-text text-danger"
                                                   *ngIf="(!RecommendedPackage.valid && RecommendedPackage.errors.pattern)">(only numbers are allowed)</small>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Batch </label>
                                          </div>


                                          <div class="col-md-3">

                                            <input type="text" class="form-control" id="FollicularPickupEndInfo.BatchNo" placeholder="Batch"
                                                   [(ngModel)]="FollicularPickupEndInfo.BatchNo"
                                                   name="FollicularPickupEndInfo.BatchNo" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Batch1="ngModel" />

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Expiry Date </label>
                                          </div>


                                          <div class="col-md-3">

                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp5" [(ngModel)]="ExpiryDate" ngbDatepicker #d5="ngbDatepicker" #DateOfBirth5="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth5.valid && (DateOfBirth5.dirty || DateOfBirth5.touched) && DateOfBirth5.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d5.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="accordion margin-bottom-20px" id="accordionExampleDOse2"
                               *ngIf="FollicularPickupEndInfo.triggertype=='Dual Trigger' || FollicularPickupEndInfo.triggertype=='Double Trigger' ">
                            <div class="card margin-bottom-5px">
                              <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingDose2">
                                <div class="row">
                                  <div class="col-md-4 text-align-center padding-right-0px">
                                    <h5 class="mb-0 height-24px">
                                      <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px border-left-female"
                                              type="button" data-toggle="collapse" data-target="#collapseDoseTwo" aria-expanded="true" aria-controls="collapseDoseTwo">
                                        <h4 class="margin-bottom-0px margin-left-8px font-size-16px">Dose2</h4>
                                      </button>
                                    </h5>
                                  </div>
                                  <div class="col-md-8 padding-right-9px">
                                    <button (click)="onSubmit()"
                                            class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right"
                                            *ngIf="PickupData2.ActivityStatus !=='Completed'"
                                            [disabled]="Medicine2.errors?.required || RecommendedPackage2.errors?.required ">
                                    Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                  </div>
                                </div>


                              </div>

                              <div id="collapseDoseTwo" class="collapse show" aria-labelledby="headingDOseTwo" data-parent="#accordionExampleDOse2">
                                <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                  <div class="card">

                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Trigger Date </label>
                                          </div>


                                          <div class="col-md-3">

                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp2" [(ngModel)]="ActivityDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth2="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth2.valid && (DateOfBirth2.dirty || DateOfBirth2.touched) && DateOfBirth2.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d2.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Trigger Time </label>
                                          </div>


                                          <div class="col-md-3">


                                            <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.TriggerTime" placeholder="Schedule Time"
                              [(ngModel)]="FollicularPickupEndInfo.TriggerTime"
                              name="FollicularPickupEndInfo.TriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                            <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.OvulationTriggerTime" placeholder="Trigger Time"
                              [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"
                              name="FollicularPickupEndInfo.OvulationTriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                            <input class="form-control" [ngxTimepicker]="picker1" [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime2" name="FollicularPickupEndInfo.OvulationTriggerTime2">
                                            <ngx-material-timepicker #picker1></ngx-material-timepicker>
                                            <!--<ngb-timepicker [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"></ngb-timepicker>-->
                                          </div>
                                          <div class="col-md-3 margin-tg-auto">
                                              <label class="margin-bottom-0px">
                                              {{FollicularPickupEndInfo.OvulationTriggerTime2| slice:11}}</label>
                                            </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Medicine </label>
                                          </div>


                                          <div class="col-md-4">
                                            <CustomDataByRequestType RequestedType="IvfFolTriggerMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode2" SelectedValue="FollicularPickupEndInfo.MedicineCode2"
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode2" (keyChange)="onAssignedToActorCode3($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode2" required #Medicine2="ngModel">
                                            </CustomDataByRequestType>


                                          </div>
                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px "
                                                   *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.MedicineName2}}</label>
                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Dose </label>
                                          </div>


                                          <div class="col-md-3">

                                            <input type="text" class="form-control" placeholder="Dose" id="FollicularPickupEndInfo.Dosage2"
                                                   [(ngModel)]="FollicularPickupEndInfo.Dosage2" required
                                                   name="FollicularPickupEndInfo.Dosage2" pattern="^[\0-9,._\-?]*$" #RecommendedPackage2="ngModel"
                                                   maxlength="5">

                                            <small class="form-text text-danger"
                                                   *ngIf="(!RecommendedPackage2.valid && RecommendedPackage2.errors.pattern)">(only numbers are allowed)</small>
                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Batch </label>
                                          </div>


                                          <div class="col-md-3">

                                            <input type="text" class="form-control" id="FollicularPickupEndInfo.BatchNo2" placeholder="Batch"
                                                   [(ngModel)]="FollicularPickupEndInfo.BatchNo2"
                                                   name="FollicularPickupEndInfo.BatchNo2" pattern="^[\sa-zA-Z0-9,._\-?]*$" #Batch2="ngModel" />

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Expiry Date </label>
                                          </div>


                                          <div class="col-md-3">

                                            <div class="date-form">
                                              <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                     name="dp4" [(ngModel)]="ExpiryDate2" ngbDatepicker #d4="ngbDatepicker" #DateOfBirth4="ngModel">
                                              <small class="form-text text-danger"
                                                     *ngIf="(!DateOfBirth4.valid && (DateOfBirth4.dirty || DateOfBirth4.touched) && DateOfBirth4.errors.required)">(Field cannot be left blank)</small>
                                              <a (click)="d4.toggle()" class="nav-link-hand">
                                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                              </a>

                                            </div>

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
